<script>
  import Icon from "@iconify/svelte";
  import FairTextLogo from "$lib/assets/fairtext_logo.svg";
  export let open = true;
</script>

<div class="w-full flex justify-between items-start sticky">
  <a href="https://fair-text.com" target="_blank"><img src={FairTextLogo} alt="Fair Text Logo" class="w-28"/></a>
  <button
    class="cursor-pointer"
    title="Schließt den Dialog der vereinfachten Version"
    on:click={() => {
      open = false;
      parent.postMessage(
        {
          type: "BRIDGE_ACTION",
          action: "CLOSE",
        },
        "*"
      );
    }}
  >
    <Icon icon="bitcoin-icons:cross-outline" class="w-5 h-5"/>
  </button>
</div>
